import React from 'react'
import ReactDOM from 'react-dom'
import { ModalArea, ModalCard, ModalHeader } from './styles';
import Close from '../../assets/icons/close.svg';

const Modal = ({ ...props }) => {

    const closeModal = () => {
        if (props.onHide) {
            props.onHide();
        }
    }

    const clickModalCard = (e) => {
        e.stopPropagation();
    }



    // O modal e montado em document.body via portal. Dentro da arvore da pagina ele fica
    // sujeito a ancestrais que criam bloco de contencao (Main e um span com position
    // absolute e overflow hidden), e o overlay deixava de cobrir a viewport - o card
    // aparecia estreito e encostado a esquerda em vez de centralizado.
    if (!props.show) {
        return null;
    }

    return ReactDOM.createPortal(
        (
            <ModalArea
                {...props}
                onClick={() => closeModal()}
            >
                <ModalCard
                    {...props}
                    onClick={(e) => clickModalCard(e)}
                >
                    <ModalHeader
                        {...props}
                    >
                        {props.onHide && (
                            <img src={Close} onClick={() => closeModal()}/>
                        )}
                    </ModalHeader>

                    {props.children}
                </ModalCard>
            </ModalArea>
        ),
        document.body,
    )
}

export default Modal;
